import { HEATING_SYSTEM_EXCHANGE_SYSTEM_KEY_LIST } from "./heating-system-exchange-system-key-list";
export const isHeatingSystemExchangeSystemKey = (value) => typeof value === "string" &&
    HEATING_SYSTEM_EXCHANGE_SYSTEM_KEY_LIST.includes(value);
